export interface SaveDashboardNote {
    dashboardNote: DashboardNote;
    status: 'new' | 'update';
}

export interface DashboardNote {
    buttonLabel: ButtonLabel;
    title: string;
    message: string;
    timestamp?: Date;
}

export type ButtonLabel = 'Disclaimer' | 'View Notes';

export function emptyNote(): DashboardNote {
    return {
        buttonLabel: 'View Notes',
        title: '',
        message: '',
    };
}
